// extracted by mini-css-extract-plugin
export var divider = "TestimonioItem-module--divider--4f2uf";
export var name = "TestimonioItem-module--name--DPZzb";
export var testimonioItem = "TestimonioItem-module--testimonio-item--Rs9Jg";
export var text = "TestimonioItem-module--text--cDyJY";